import ElementPlus from 'element-plus'

// Importa o idioma português brasileiro
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/pt-br'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(ElementPlus, { locale })
})
